import { FormHelperText, FormHelperTextTypeMap } from '@material-ui/core';
import { BaseProps } from '@material-ui/core/OverridableComponent';
import React from 'react';

const ErrorHelperText: React.FC<BaseProps<FormHelperTextTypeMap>> = ({
  className,
  children,
  ...props
}: BaseProps<FormHelperTextTypeMap>) => (
  <FormHelperText error {...props} className={className} variant="filled">
    {children}
  </FormHelperText>
);

export default ErrorHelperText;
